import React, {useState, useEffect} from 'react'
import ProfileComponent from '../components/Profile/Profile'
import {getAccessToken} from '../services/accessToken'
import { useSelector } from 'react-redux';
import socialService from '../services/socialapi'
const ProfilePage = () => {

    const [items, setItems] = useState(null)
    
    console.log("personal content on page", items)
    return (
        <>
            <div className="bg-gray-900">
                <ProfileComponent />
            </div>
        </>
    )
}

export default ProfilePage